import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { getProjectProcessingStatus, restartProject } from '../../../services/projectService';
import NotificationToast from '../../NotificationToast';
import Button from '../../StoraEnsoComponents/Button';

const Title = styled.p`
  text-align: center;
  margin-bottom: 16px;
  font-size: 1.75rem;
  font-weight: 500;
  text-transform: uppercase;
`;

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  background-color: ${({theme, isError}) => isError ? theme.colors.negative_bg : theme.colors.attention_bg };
  border: 1px solid ${({theme, isError}) => isError ? theme.colors.negative : theme.colors.attention };
  color: ${({theme}) => theme.colors.heading_dark};

  ${Button} {
    width: 100%;
    margin-top: 16px;
  }
`;

function ProcesssingCheck({ id }) {
  const [processingStatus, setProcessingStatus] = useState(null);
  const [actionResult, setActionResult] = useState(null);

  useEffect(() => {
      getProjectProcessingStatus(id)
      .then(data=>{
          setProcessingStatus(data);
      });
  }, []);

  const handleRestartProject = ()=>{
    restartProject(id)
      .then(() => {
        getProjectProcessingStatus(id)
        .then(data=>{
            setProcessingStatus(data);
        });
        setActionResult({
          kind: 'success',
          message: 'Project has been successfully restarted.'
        });
      })
      .catch(() => {
        setActionResult({
          kind: 'error',
          message: 'An error has occurred while restarting project. Try it once again or create a ticket'
        });
      });
  }

  if(!processingStatus) {
    return null;
  }

  return (
    <Grid isError={processingStatus.error}>
      <NotificationToast
      toastId="processingCheck"
      kind={actionResult?.kind}
      message={actionResult?.message}
      onClose={() => setActionResult(null)}
    />
      <div>
          <Title>Processing Check</Title>
          <div><strong>Project name:</strong> {processingStatus.projectName}</div>
          <div><strong>Project ID:</strong> {processingStatus.projectId}</div>
          <div><strong>Status:</strong> {processingStatus.status}</div>
          {
            processingStatus.error &&
              <Button onClick={handleRestartProject}> Restart Project</Button>
          }
      </div>


    </Grid>
  );
}

export default ProcesssingCheck;